import styled from 'styled-components';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { spacing, palette, variant } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';
import { Text } from '../Text/Text.es.js';
var variantStyles = variant({
  prop: "variant",
  variants: {
    empty: {
      color: "neutral.400"
    },
    success: {
      color: "primary.500"
    },
    danger: {
      color: "danger.500"
    }
  }
});
var Icon = styled(Box).withConfig({
  componentId: "asoz0b-0"
})(["font-size:0;padding-bottom:", ";"], spacing("sm"));
var Content = styled(Text).withConfig({
  componentId: "asoz0b-1"
})(["color:", ";"], palette("neutral.400"));
var UiState = styled(Box).withConfig({
  componentId: "asoz0b-2"
})(["width:100%;height:100%;display:flex;flex-direction:column;align-items:", ";", ";"], function (_ref) {
  var align = _ref.align;
  return align;
}, variantStyles);
export { Content, Icon, UiState };